import Settings from "./utils/CarrotConfig"

export function AdminShellRedirector() {
  function inIframe() {
    return window.self !== window.top
  }

  // In local staging mode we want to view admin-v2 standalone at its own port,
  // so skip the redirect that would otherwise bounce it back into admin-shell
  // (which isn't running). DATA_MODE is only set by config/local-staging.js.
  // This does not affect the iframe scenario, which is already gated on inIframe().
  const isLocalNoBackend = Boolean(Settings.DATA_MODE)

  if (!isLocalNoBackend && !inIframe()) {
    const adminShellUrl = Settings.ADMIN_SHELL_URL
    window.location.href = `${adminShellUrl}/admin/legacy${window.location.pathname}`
  }

  return null
}
